import { Box, Chip, Typography, Button } from "@mui/joy";
import { CheckCircle2, Clock, PackageCheck, Mail } from "lucide-react";
import { useEffect } from "react";
import moment from "moment";

import TaskActionComponent from "../../../components/Tasks/components/TaskAction";
import { useDocument } from "../../../hooks/query";

import { useContractSigning } from "./hooks";
import { ContractReview } from "./ContractReview";

interface ITaskComponent {
    activeTask: any;
    measurements: any;
    onComplete: () => void;
    actionProgress: any;
}

export default function TaskComponent(props: ITaskComponent) {
    const { activeTask, onComplete, actionProgress } = props;
    const { CreatedAt, Status } = activeTask;
    const {
        contractDocument,
        markAsSigned,
        triggerSigning,
        isUpdatingStatus,
        isTriggeringSigning,
    } = useContractSigning();

    useEffect(() => {
        const scrollableDiv = document.getElementById("project-details-parent");
        if (scrollableDiv) {
            //scrollableDiv.scrollTop = 0; // or use scrollTo
            scrollableDiv.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, []);

    return (
        <Box>
            <Box mt={2} ml={1} mr={1}>
                <Typography startDecorator={<PackageCheck size={16} />} level="body-sm" gutterBottom>
                    Task
                </Typography>
                <Typography level="h4" sx={{ fontWeight: 500 }}>
                    Contact Signing
                </Typography>

                <Box mt={2} display={"flex"} gap={1} alignItems="center">
                    <Chip
                        color={Status === "COMPLETED" ? "success" : "warning"}
                        sx={{ fontSize: 12, border: "1px solid", borderColor: "divider" }}
                    >
                        {Status}
                    </Chip>
                    <Chip color="neutral" variant="outlined" sx={{ fontSize: 12 }} startDecorator={<Clock size={14} />}>
                        Created On: {moment(CreatedAt).format("MM/DD/YYYY")}
                    </Chip>
                    {contractDocument?.Status === "GENERATED" && (
                        <Button
                            size="sm"
                            variant="soft"
                            color="primary"
                            startDecorator={<Mail size={16} />}
                            onClick={triggerSigning}
                            loading={isTriggeringSigning}
                            sx={{ ml: "auto" }}
                        >
                            Send for signing
                        </Button>
                    )}
                    {contractDocument?.Status !== "SIGNED" && contractDocument?.Status !== "GENERATED" && (
                        <Button
                            size="sm"
                            variant="soft"
                            color="success"
                            startDecorator={<CheckCircle2 size={16} />}
                            onClick={markAsSigned}
                            loading={isUpdatingStatus}
                            sx={{ ml: "auto" }}
                        >
                            Mark as signed
                        </Button>
                    )}
                </Box>

                <Box mt={3}>
                    <Box flex={1}>
                        <Typography level={"body-sm"} sx={{ color: "text.primary", fontWeight: 600 }} gutterBottom>
                            Description
                        </Typography>
                        <Typography level={"body-md"} sx={{ color: "text.primary" }}>
                            The primary goal of the Contract Signing stage is to finalize the agreement between all
                            parties, ensuring mutual understanding of project terms, responsibilities, and expectations.
                            This stage formalizes commitments, secures approvals, and provides a legal framework for the
                            roofing project, ensuring a smooth execution with clearly defined obligations.
                        </Typography>
                    </Box>
                </Box>
                <ContractReview />
                <TaskActionComponent
                    taskName={"Contact Signing"}
                    onComplete={onComplete}
                    actionProgress={actionProgress}
                    isNextEligible={contractDocument?.Status === "SIGNED"}
                />
            </Box>
        </Box>
    );
}
